import { X } from "lucide-react";
import { Input } from "./ui/input";
import { ProductCombobox } from "./ProductCombobox";
import { EmptyState, TABLE_HEAD, TABLE_ROW } from "./common";
import { money, qtyFmt } from "../lib/api";

export const cartTotal = (lines) => lines.reduce((s, l) => s + (Number(l.qty) || 0) * (Number(l.price) || 0), 0);
export const cartItems = (lines) => lines.map((l) => ({ product_id: l.product.id, qty: Number(l.qty), unit_price: Number(l.price) }));

export function CartEditor({ products, depotId, lines, setLines, lockPrice = false, testid = "cart" }) {
  const add = (p) => setLines((ls) => (ls.some((l) => l.product.id === p.id) ? ls : [...ls, { product: p, qty: "1", price: String(p.sell_price ?? 0) }]));
  const update = (i, k, v) => setLines((ls) => ls.map((l, j) => (j === i ? { ...l, [k]: v } : l)));
  const remove = (i) => setLines((ls) => ls.filter((_, j) => j !== i));
  const avail = (p) => (depotId ? p.stock?.[depotId] ?? 0 : p.qty);
  return (
    <div className="space-y-3" data-testid={testid}>
      <ProductCombobox products={products} value={null} onChange={add} depotId={depotId} testid={`${testid}-product`} />
      {!lines.length ? <EmptyState text="Add products to start" testid={`${testid}-empty`} /> : (
        <div className="overflow-x-auto rounded-md border border-slate-800">
          <table className="w-full text-sm">
            <thead className={TABLE_HEAD}>
              <tr><th className="px-3 py-2 text-left">Item</th><th className="px-3 py-2 text-left w-24">Qty</th><th className="px-3 py-2 text-left w-32">Price</th><th className="px-3 py-2 text-right">Total</th><th className="w-8" /></tr>
            </thead>
            <tbody>
              {lines.map((l, i) => (
                <tr key={l.product.id} className={TABLE_ROW} data-testid={`${testid}-line-${i}`}>
                  <td className="px-3 py-2"><div className="font-medium">{l.product.name}</div><div className="font-mono text-[11px] text-slate-500">{l.product.sku} · {qtyFmt(avail(l.product))} {l.product.unit} available</div></td>
                  <td className="px-3 py-2"><Input type="number" step="any" min="0" value={l.qty} onChange={(e) => update(i, "qty", e.target.value)} className="h-8 bg-slate-950" data-testid={`${testid}-qty-${i}`} /></td>
                  <td className="px-3 py-2"><Input type="number" min="0" value={l.price} disabled={lockPrice} onChange={(e) => update(i, "price", e.target.value)} className="h-8 bg-slate-950" data-testid={`${testid}-price-${i}`} /></td>
                  <td className="px-3 py-2 text-right font-mono">{money((Number(l.qty) || 0) * (Number(l.price) || 0))}</td>
                  <td className="px-1"><button type="button" onClick={() => remove(i)} className="p-1 text-slate-500 hover:text-rose-400" data-testid={`${testid}-remove-${i}`}><X className="h-4 w-4" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="flex items-center justify-between rounded-md border border-slate-800 bg-slate-950 px-4 py-3">
        <span className="label-mono">Total</span>
        <span className="font-mono text-xl font-bold text-emerald-400" data-testid={`${testid}-total`}>{money(cartTotal(lines))}</span>
      </div>
    </div>
  );
}
